export const apiName: string = 'gps-modelos';
export const modeloGpsRoute: string = 'modelos-gps';
export const modeloGpsStorage: string = 'modelos-gps';
export const modeloGpsModuleName: any = {plural: 'Modelos de GPS', single: 'Modelo de GPS'};

export const modeloGpsQuery: any = {
    "where":{
        "ativo":true,
        "modelo":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"modelo"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/modelos-gps/shared/data.service.ts
 **/